import React, { Suspense } from "react";
import type { CitySelectProps } from "./CitySelectInner";

const LazyCitySelect = React.lazy(() =>
  import("./CitySelectInner").then((mod) => ({
    default: mod.CitySelect,
  })),
);

export type { CityOption, CitySelectProps } from "./CitySelectInner";

export function CitySelect(props: CitySelectProps) {
  return (
    <Suspense
      fallback={
        <div className="border rounded-md px-3 py-2 text-sm text-gray-500 bg-gray-50">
          Loading city selector…
        </div>
      }
    >
      <LazyCitySelect {...props} />
    </Suspense>
  );
}
